<template>
  <NuxtLink
    :to="dragging ? undefined : actu.route"
    class="actu-playstation-item"
    :draggable="false"
  >
    <div class="img-container">
      <NuxtImg
        v-if="actu.image_desktop?.url"
        :src="actu.image_desktop.url"
        :alt="actu.title"
        width="350"
        height="195"
        quality="80"
        fit="cover"
        sizes="xs:100vw sm:100vw md:350px"
        format="auto"
      />
    </div>
    <div class="text-container">
      <p class="date">{{ dateToString(actu.created_at) }}</p>
      <p class="title">{{ capitalize(actu.title) }}</p>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { Get } from 'type-fest'
import type { FormattedArticle } from '~/types'

withDefaults(
  defineProps<{
    actu: NonNullable<Get<FormattedArticle, 'sideContent.card'>>
    dragging?: boolean
  }>(),
  {
    actu: () => ({
      id: 0,
      title: '',
      route: '',
      image_desktop: {
        url: '',
      },
      created_at: '',
    }),
    dragging: false,
  },
)
</script>

<style lang="scss" scoped>
.actu-playstation-item {
  color: $dark;
  text-decoration: none;

  .img-container {
    width: 100%;
    height: 19.5rem;
    background: #ccc;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .text-container {
    padding: 2rem 0 3rem;
    border-bottom: 1px solid $lightGreyBorder;

    .date {
      color: $lightGrey;
      font-size: 1rem;
      line-height: 2.2rem;
    }

    .title {
      height: 4.4rem;
      color: $dark;
      font-size: 1.5rem;
      line-height: 2.2rem;
    }
  }
}
</style>
